import { ChevronLeft } from "lucide-react";
import InertIcon from "./InertIcon";
import DemoAvatar from "./DemoAvatar";
import { resolveConversationPhoto } from "../hooks/demoUtils";
import { resolveDemoIcon } from "../icons/defaultIcons";
import type { Conversation, InboxDemoIcons } from "../data/types";

type ConversationHeaderProps = {
  conversation?: Conversation;
  icons: InboxDemoIcons;
  onBack?: () => void;
};

function BackButton({ onBack }: { onBack?: () => void }) {
  if (!onBack) return null;

  return (
    <button
      aria-label="返回消息列表"
      className="flex size-8 shrink-0 items-center justify-center rounded-[14px] text-default-600 transition-colors hover:bg-default-100 md:hidden"
      type="button"
      onClick={onBack}
    >
      <ChevronLeft size={20} strokeWidth={1.75} />
    </button>
  );
}

export default function ConversationHeader({
  conversation,
  icons,
  onBack,
}: ConversationHeaderProps) {
  if (!conversation) {
    return (
      <div className="flex h-[72px] items-center gap-1 border-b border-default-100 px-3 text-sm text-default-500 md:px-6">
        <BackButton onBack={onBack} />
        选择一个会话
      </div>
    );
  }

  return (
    <header className="flex items-center gap-2 border-b border-default-100 px-3 py-3 md:gap-4 md:px-6 md:py-4">
      <BackButton onBack={onBack} />
      <div className="flex min-w-0 flex-1 items-center gap-2">
        <DemoAvatar
          initial={conversation.avatarInitial}
          name={conversation.name}
          src={resolveConversationPhoto(conversation)}
          tone={conversation.avatarTone}
        />
        <div className="min-w-0">
          <p className="truncate text-base font-semibold leading-7 text-foreground md:text-lg">
            {conversation.name}
          </p>
        </div>
      </div>
      <div className="hidden items-center gap-[12px] md:flex">
        <InertIcon className="flex size-8 items-center justify-center rounded-[14px] text-default-500">
          {resolveDemoIcon(icons, "messageCircleOff")}
        </InertIcon>
        <InertIcon className="flex size-8 items-center justify-center rounded-[14px] text-default-500">
          {resolveDemoIcon(icons, "eye")}
        </InertIcon>
        <InertIcon className="flex size-8 items-center justify-center rounded-[14px] text-default-500">
          {resolveDemoIcon(icons, "panelRight")}
        </InertIcon>
      </div>
    </header>
  );
}
